import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiCollectionResponse } from '../interfaces/responses/api-response';

/**
 * Palier d'évaluation vu par l'administration : une tranche de score, ce qu'on
 * en dit, et le plan qu'on propose — dans les trois langues du produit.
 */
export interface EvaluationBandAdmin {
  id: number;
  /** Code stable. Non modifiable : le rapport de diagnostic s'y réfère. */
  code: string;

  labelAr: string;
  labelFr: string;
  labelEn: string;

  planLabelAr: string;
  planLabelFr: string;
  planLabelEn: string;

  minPercentage: number;
  maxPercentage: number;

  color?: string | null;
  displayOrder: number;
  isActive: boolean;
}

/**
 * Paliers d'évaluation — les tranches de score qui décident du plan proposé à
 * l'élève dans le rapport de diagnostic.
 *
 * Endpoints :
 *   GET /api/admin/evaluation-bands
 *   PUT /api/admin/evaluation-bands
 */
@Injectable({ providedIn: 'root' })
export class EvaluationBandService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.BASE_URL}/admin/evaluation-bands`;

  list(): Observable<ApiCollectionResponse<EvaluationBandAdmin>> {
    return this.http.get<ApiCollectionResponse<EvaluationBandAdmin>>(this.base);
  }

  /**
   * Enregistre **tous** les paliers d'un coup : leurs bornes doivent couvrir
   * 0 à 100 sans trou ni recouvrement, et le serveur ne peut le vérifier qu'en
   * les recevant ensemble.
   */
  save(
    bands: EvaluationBandAdmin[],
  ): Observable<ApiCollectionResponse<EvaluationBandAdmin>> {
    return this.http.put<ApiCollectionResponse<EvaluationBandAdmin>>(
      this.base,
      bands.map((b) => ({
        id: b.id,
        labelAr: b.labelAr,
        labelFr: b.labelFr,
        labelEn: b.labelEn,
        planLabelAr: b.planLabelAr,
        planLabelFr: b.planLabelFr,
        planLabelEn: b.planLabelEn,
        minPercentage: b.minPercentage,
        maxPercentage: b.maxPercentage,
        color: b.color || null,
      })),
    );
  }
}
